<template>
	<footer>
		<div class="widthBox acea-row row-between">
			<div class="left">
				<div class="title">关于我们</div>
				<div class="info" v-if="config.bottom">
					{{config.bottom.aboutdescribe}}
				</div>
			</div>
			<div class="right">
				<div class="title">联系我们</div>
				<div class="cont" v-if="config.bottom">
					<p class="acea-row">
						<span class="icon iconfont icon-weizhi acea-row row-center-wrapper"></span>
						{{config.bottom.address}}
					</p>
					<p class="acea-row">
						<span class="icon iconfont icon-24gf-telephone2 acea-row row-center-wrapper"></span>
						<span class="text">{{config.bottom.mobile}}</span>
						<!-- |
						<span class="text" style="margin-left:20px;">000-0000-000</span> -->
					</p>
					<p class="acea-row">
						<span class="icon iconfont icon-youxiang acea-row row-center-wrapper"></span>
						{{config.bottom.email}}
					</p>
				</div>
			</div>
		</div>
		<div style="margin-top:20px;text-align:center">{{config.site_info.site_icp}}</div>
	</footer>
</template>

<script>
	export default {
	  computed: {
		config() {
			return this.$store.state.config
		},
	  },
	  created() {
	  },
	  methods:{
	  }
	}
</script>

<style lang="scss">
	footer{
		background:#0D2532;
		color:#FFF;
		padding:40px 0;
		.title{
			font-size:18px;
			line-height:40px;
			position: relative;
		}
		.left{
			width:50%;
			.info{
				font-size:14px;
			}
		}
		.right{
			width:39%;
			.title{
				border-bottom:1px solid #FFF;
				&::after{
					content:'';width:60px;height:1px;background:#FFF;position: absolute;z-index: 1;left:0;bottom:0;
				}
			}
			.cont{
				p{
					margin-top:16px;
					.icon{
						width:26px;
						height:26px;
						border-radius:2px;
						margin-right:10px;
						font-size:16px;
						color: rgba(255,255,255,0.50);
						background: rgba(255,255,255,0.30);
						img{
							width:15px;
						}
					}
					line-height:26px;
					.text{
						vertical-align: middle;
						margin-right:20px;;
						line-height:26px;
						
					}
				}
				
			}
		}
	}
	
	@media screen and(max-width:768px) {
		footer{
			.left{
				width:100%;
			}
			.right{
				width:100%;
				.title::after {
				    bottom: -2px;
				}
			}
		}
	}
</style>
